import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

// Product categories are configured in Settings and stored as the
// `productCategories` setting. This provider loads them once (per login) so every
// screen shows the same, admin-controlled list. Falls back to the seed list.
export const DEFAULT_CATEGORIES = [
  'SWEETS', 'SNACKS', 'NAMKEENS', 'POWDERS', 'PICKLES - VEG', 'PICKLES - NON VEG',
  'PAPADS & FRYUMS', 'DRY FRUITS', 'GROCERY', 'VEGETABLES', 'MASALA SAMAN',
  'DAILY ESSENTIALS', 'POOJA ITEMS', 'NON VEG',
];

const Ctx = createContext(null);

export const CategoriesProvider = ({ children }) => {
  const { user, can } = useAuth();
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);

  const reloadCategories = useCallback(() => {
    if (!user || !can('products:read')) return;
    api.get('/products/categories')
      .then(({ data }) => { if (Array.isArray(data.categories) && data.categories.length) setCategories(data.categories); })
      .catch(() => {});
  }, [user, can]);

  useEffect(() => { reloadCategories(); }, [reloadCategories]);

  return <Ctx.Provider value={{ categories, reloadCategories, setCategories }}>{children}</Ctx.Provider>;
};

export const useCategories = () => useContext(Ctx) || { categories: DEFAULT_CATEGORIES, reloadCategories: () => {}, setCategories: () => {} };
